import Environment from '@cobliteam/react-environments';
import { createClient } from '@prismicio/client';
import type { AllDocumentTypes } from './types/support-cobli.generated';

const env = Environment.getInstance().getEnvironment();

export const repositoryName = env.prismicRepositorySupport;

const client = createClient<AllDocumentTypes>(repositoryName);

export default client;
